import { put, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';

import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import request from 'utils/request';
import urls from 'utils/config';
import {
  setAddCourseFailed,
  setCourseSuccess,
  bulkCourseUploadSuccess,
  bulkCourseUploadFailure,
  clearError,
  getCourse,
  getAllCourses
} from '../actions';
import { CoursesActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* saveCourse({ data }) {
  const { formData, callBack } = data;
  const url = `${API_BASE_URL}/courses`;

  const response = yield request({
    method: 'post',
    data: formData,
    url,
  });
  if (response.success) {
    callBack(response.raw?.id);
    yield put(setCourseSuccess(response.raw));
    yield put(getAllCourses());
    yield put(clearError());
    Notify('Course Created Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    if (response.statusCode === 409) {
      networkErrorHandler(response?.statusCode, `The course code "${formData.code.toUpperCase()}" is already in use`);
    } else {
      networkErrorHandler(response?.statusCode, response?.message);
    }
    yield put(setAddCourseFailed());
  }
}

export function* watchAddCourses() {
  yield takeLatest(CoursesActionTypes.ADD_COURSE, saveCourse);
}

function* saveBulkCourseUpload({ payload }) {
  const { data, callBack1, callBack2 } = payload;
  data.forEach((entry) => {
    entry.administrationLevelItemId = entry.administrationLevelItem.id;
    entry.status = 'active';
  });
  const url = `${API_BASE_URL}/courses/bulk`;

  const response = yield request({
    method: 'post',
    data,
    url,
  });

  if (response.success) {
    yield put(getCourse(1));
    yield put(getAllCourses());
    yield put(bulkCourseUploadSuccess());
    if (response.raw.length > 0) {
      const formartedData = [];
      response.raw.forEach((failedEntry) => {
        failedEntry.course.reason = 'Course code already exists';
        formartedData.push(failedEntry.course);
      });
      callBack2(formartedData);
    } else {
      callBack1();
      Notify('Courses Created Successfully!', {
        position: TOP_RIGHT,
        status: SUCCESS,
      });
    }
  } else {
    yield put(bulkCourseUploadFailure());
  }
}

export function* onBulkCoursesUpload() {
  yield takeLatest(
    CoursesActionTypes.BULK_COURSES_UPLOAD,
    saveBulkCourseUpload
  );
}
